






import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import { openExternalUrl } from "@/shared/urlHelper";
@Component({
  components: {}
})
export default class ExternalLink extends Vue {
  @Prop({ required: true })
  url: string;

  onClick () {
    openExternalUrl(this.url);
  }
}
